// extracted by mini-css-extract-plugin
module.exports = {"menu":"widget-demo--menu--11r8r","info":"widget-demo--info--3mW7L","signout":"widget-demo--signout--2xcwv"};